import { DateFormatType } from './date-format-key'
import type { IResolvedDateFormat } from './i-resolved-date-format'

function detectBrowserDateFormat(): IResolvedDateFormat {
  try {
    const locale = navigator.language || 'en'
    const parts = new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).formatToParts(new Date(2001, 1, 3))

    const dayIndex = parts.findIndex(part => part.type === 'day')
    const monthIndex = parts.findIndex(part => part.type === 'month')

    if (dayIndex === -1 || monthIndex === -1) {
      return DateFormatType.DdMm
    }

    return monthIndex < dayIndex ? DateFormatType.MmDd : DateFormatType.DdMm
  } catch {
    return DateFormatType.DdMm
  }
}

export function resolveDateFormat(value: DateFormatType | null): IResolvedDateFormat {
  return value === null ? detectBrowserDateFormat() : value
}
